var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctx-wrap"},[_c('keep-alive',{attrs:{"include":_vm.pathCacheList}},[_c('router-view')],1),_c('WaterMark')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }